export default "__VITE_ASSET__80239fb3__"